async function getJson(url) {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`API request failed (${response.status})`);
  }

  return response.json();
}

export async function fetchServiceBySlug(slug) {
  return getJson(`/api/services/${slug}`);
}

export async function fetchServicePreviews() {
  const payload = await getJson('/api/services');
  return Array.isArray(payload?.items) ? payload.items : [];
}
